import { useMutation } from "@tanstack/react-query";
import { PipelinesPipelines, Streams, PipelinesRules, PipelinesConnections } from "@graylog/server-api";
import SourceGenerator from "logic/pipelines/SourceGenerator";
import { DEFAULT_PIPELINE } from "components/pipelines/types";
const createStream = async (stream) => Streams.create({
  entity: {
    matching_type: void 0,
    rules: void 0,
    content_pack: void 0,
    description: void 0,
    ...stream
  },
  share_request: void 0
});
const startStream = async (streamId) => Streams.resume(streamId);
const createPipeline = (pipeline) => {
  const requestPipeline = {
    ...DEFAULT_PIPELINE,
    ...pipeline
  };
  return PipelinesPipelines.createFromParser({
    ...requestPipeline,
    source: SourceGenerator.generatePipeline(requestPipeline)
  });
};
const updateRouting = async (params) => PipelinesPipelines.routing({ remove_from_default: void 0, stream_id: void 0, ...params });
const deleteStream = async (streamId) => Streams.remove(streamId);
const deletePipeline = async (pipelineId) => PipelinesPipelines.remove(pipelineId);
const deleteRoutingRule = async (ruleId) => PipelinesRules.remove(ruleId);
const connectPipeline = async ({ pipelineId, streamId }) => PipelinesConnections.connectStreams({ stream_ids: [streamId], pipeline_id: pipelineId });
const useSetupInputMutations = () => {
  const createStreamMutation = useMutation({
    mutationFn: createStream
  });
  const startStreamMutation = useMutation({
    mutationFn: startStream
  });
  const createPipelineMutation = useMutation({
    mutationFn: createPipeline
  });
  const updateRoutingMutation = useMutation({
    mutationFn: updateRouting
  });
  const deleteStreamMutation = useMutation({
    mutationFn: deleteStream
  });
  const deletePipelineMutation = useMutation({
    mutationFn: deletePipeline
  });
  const deleteRoutingRuleMutation = useMutation({
    mutationFn: deleteRoutingRule
  });
  const connectPipelineMutation = useMutation({
    mutationFn: connectPipeline
  });
  return {
    createStreamMutation,
    startStreamMutation,
    createPipelineMutation,
    updateRoutingMutation,
    deleteStreamMutation,
    deletePipelineMutation,
    deleteRoutingRuleMutation,
    connectPipelineMutation
  };
};
export default useSetupInputMutations;
